import { render } from "./BuyerPageView.vue?vue&type=template&id=05e1aaa6"
import script from "./BuyerPageView.vue?vue&type=script&lang=js"
export * from "./BuyerPageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__